import { Link } from 'react-router-dom';

export default function SafetySection() {
  const tips = [
    'Verify website sources before making purchases',
    'Check product information and reviews carefully',
    'Avoid clicking suspicious or unknown links',
    'Protect personal and payment information',
    'Use secure and trusted payment methods',
    'Research sellers and check return policies',
  ];

  const risks = [
    { risk: 'Fake websites', action: 'Verify official sources and check URL authenticity' },
    { risk: 'Unknown sellers', action: 'Research seller reputation before purchasing' },
    { risk: 'Suspicious links', action: 'Avoid clicking unfamiliar URLs or pop-up offers' },
    { risk: 'Unverified products', action: 'Cross-reference QC photos and product descriptions' },
    { risk: 'Payment fraud', action: 'Only use secure, trusted payment gateways' },
  ];

  return (
    <section id="safety" className="py-16 md:py-24 px-4 md:px-6 bg-background-100 scroll-mt-20">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
            Safety First
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4 text-balance">
            Is Vigorbuy Spreadsheet Safe?
          </h2>
          <p className="text-foreground-500 text-base max-w-2xl mx-auto">
            Safety is the most important part of online shopping. Here is what every <strong>vigorbuy spreadsheet review</strong> confirms about staying protected while browsing and purchasing online.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          <div className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70">
            <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-5 flex items-center gap-2">
              <i className="ri-shield-check-line text-accent-500"></i> Always Remember
            </h3>
            <ul className="space-y-3">
              {tips.map((tip) => (
                <li key={tip} className="flex items-start gap-3 text-sm text-foreground-700">
                  <i className="ri-check-line text-accent-500 mt-0.5 flex-shrink-0"></i>
                  <span>{tip}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70">
            <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-5 flex items-center gap-2">
              <i className="ri-error-warning-line text-primary-500"></i> Risk Awareness
            </h3>
            <div className="space-y-2">
              {risks.map((r) => (
                <div key={r.risk} className="flex items-start gap-3 p-3 rounded-lg bg-background-100">
                  <div className="flex-1">
                    <p className="text-sm font-medium text-foreground-800 whitespace-nowrap">{r.risk}</p>
                    <p className="text-xs text-foreground-500 mt-0.5">{r.action}</p>
                  </div>
                  <i className="ri-arrow-right-line text-foreground-400 mt-1 flex-shrink-0"></i>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="text-center">
          <Link
            to="/vigorbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-accent-500 text-white text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap"
          >
            Read Complete Safety Guide <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}